import { signalStore, withState } from "@ngrx/signals";
import { initialProviderState } from "./provider.state";
import { withProviderComputed } from "./provider.computed";
import { withProviderApiMethods } from "./provider.methods.api";
import { withProviderStateMethods } from "./provider.methods.state";

export const ProviderStore = signalStore(
    { providedIn: 'root' },
    withState(initialProviderState),
    withProviderApiMethods,
    withProviderStateMethods,
    withProviderComputed
);
